import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_spread_props } from "@swc/helpers/_/_object_spread_props";
import { DraftStatusType, serviceModel } from '~/models';
import { toCustomPageDTO } from '~/models/custom-page/model';
export const defaultCoverLetterNewClient = "We've created an agreement in Anchor, a billing platform that we use to automate the payment process so both of us can save time and effort.\n\nIt includes a detailed description of the services we agreed on, the price, and the billing terms.\n\nPlease review and approve the agreement.";
export function contactHasAgreement(contact, agreements, proposals) {
    if (!(contact === null || contact === void 0 ? void 0 : contact.customerId())) return false;
    const hasContact = (r)=>!r.isSample && !r.withdrawnForEditing && r.customer.id === contact.customerId();
    return !!agreements && agreements.some(hasContact) || !!proposals && proposals.some(hasContact);
}
export function fromAgreementStudioCommon(param) {
    let { id, data, title, agreementName, effectiveDate } = param;
    var _data_legalTermsDocuments, _data_customPages;
    var _data_serviceBundles;
    return {
        id,
        title,
        agreementName,
        effectiveDate,
        extraClause: data.extraClause,
        requirePaymentMethod: data.requirePaymentMethod,
        allowManualPayments: data.allowManualPayments,
        customNotificationText: data.customNotificationText,
        isExistingCustomer: data.isExistingCustomer,
        netTerms: data.netTerms,
        coverLetter: data.coverLetter,
        feeControls: {
            coverCreditCardFees: data.coverCreditCardFees,
            coverDirectDebitFees: false
        },
        legalTermsDocuments: (_data_legalTermsDocuments = data.legalTermsDocuments) !== null && _data_legalTermsDocuments !== void 0 ? _data_legalTermsDocuments : [],
        services: data.services.map(serviceModel.toDTO),
        serviceBundles: ((_data_serviceBundles = data.serviceBundles) === null || _data_serviceBundles === void 0 ? void 0 : _data_serviceBundles.bundles.length) ? {
            bundles: data.serviceBundles.bundles.map((b)=>_object_spread_props(_object_spread({}, b), {
                    services: b.services.map(serviceModel.toDTO)
                }))
        } : undefined,
        amendmentsApprovalMethod: data.amendmentsApprovalMethod,
        invoicesApprovalMethod: data.invoicesApprovalMethod,
        requestAccountantAccess: data.requestAccountantAccess,
        introVideo: data.introVideo,
        expirationDate: data.expirationDate,
        customPages: ((_data_customPages = data.customPages) !== null && _data_customPages !== void 0 ? _data_customPages : []).map(toCustomPageDTO),
        status: {
            type: DraftStatusType.Active
        }
    };
}
